import { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";

/* /api/meta est la même réponse pour tout le monde et ne change pas pendant une visite.
   Elle était demandée 4 fois par chargement (HeaderNav, Watchlist, Pricing, Dashboard) :
   autant de requêtes concurrentes qui pouvaient être annulées par une navigation, et
   autant d'occasions d'écrire un faux « pas de source de données ». Un seul appel est
   partagé ici, mémorisé au niveau du module : une erreur ne dit jamais « vide », elle
   dit « on ne sait pas encore » (meta reste null). */

const MetaContext = createContext(null);

let cached = null;
let inflight = null;

export function fetchMeta() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api.get("/meta")
      .then((r) => { cached = r.data; return cached; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function MetaProvider({ children }) {
  const [meta, setMeta] = useState(cached);
  useEffect(() => {
    if (cached) return;
    let alive = true;
    fetchMeta().then((d) => { if (alive) setMeta(d); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return <MetaContext.Provider value={meta}>{children}</MetaContext.Provider>;
}

export function useMeta() {
  return useContext(MetaContext);
}
